import React from 'react';
import {useStyles} from './AppVersions.style';
import {useUserContext} from '../../contexts/UserContext';
import appVersions from './AppVersions.data';
import AppVersionCard from './AppVersionCard/AppVersionCard';

const AppVersions: React.FC = () => {
    const userStore = useUserContext();
    const classes = useStyles();

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const orderedVersions = [...appVersions].reverse();

    return (
        <div className={classes.app_versions_container}>
            {orderedVersions.map((appVersion, i) => (
                <AppVersionCard
                    key={appVersion.version}
                    appVersion={appVersion}
                    latest={i === 0}
                />
            ))}
        </div>
    )
}

export default AppVersions;
